/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL Encoder / Decoder`)
};

const es_ue_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador/Decodificador de URL`)
};

const de_ue_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL-Kodierer / Dekoder`)
};

const nl_ue_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL-encoder / -decoder`)
};

const fr_ue_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encodeur / Décodeur URL`)
};

const it_ue_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificatore URL / Decodificatore`)
};

const pt_br2_ue_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador / Decodificador de URL`)
};

const pt_ue_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador / Descodificador de URL`)
};

const ja_ue_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URLエンコーダー / デコーダー`)
};

const zh_ue_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL 编码器 / 解码器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_h1", locale)
	if (locale === "en") return en_ue_h1(inputs)
	if (locale === "es") return es_ue_h1(inputs)
	if (locale === "de") return de_ue_h1(inputs)
	if (locale === "nl") return nl_ue_h1(inputs)
	if (locale === "fr") return fr_ue_h1(inputs)
	if (locale === "it") return it_ue_h1(inputs)
	if (locale === "pt-BR") return pt_br2_ue_h1(inputs)
	if (locale === "pt") return pt_ue_h1(inputs)
	if (locale === "ja") return ja_ue_h1(inputs)
	return zh_ue_h1(inputs)
};